/**
 * SPDX-License-Identifier: MPL-2.0
 * Copyright 2023-2024 (c) Marc Fischer, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2023-2024 (c) Daniel Littfinski, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import { Configuration } from './generated';
import {
  CompanyApi,
  UsersApi,
  FairsApi,
  OpcUaClientApi,
  SoftwaresApi,
  AuthenticationApi,
  AntiforgeryTokenApi,
  MachinesApi,
  MeApi,
} from './generated/api';
import { ENVs } from './ENV';
export * from './generated/models';

export var config = new Configuration({
  basePath: window.location.protocol + '//' + window.location.host,
});

export default {
  Company: new CompanyApi(config),
  Users: new UsersApi(config),
  Fairs: new FairsApi(config),
  OpcUaClient: new OpcUaClientApi(config),
  Software: new SoftwaresApi(config),
  Authentication: new AuthenticationApi(config),
  Antiforgery: new AntiforgeryTokenApi(config),
  Machines: new MachinesApi(config),
  Me: new MeApi(config),
};

// Create changing urls to prevent caching in the browser
const noCachUrl = (url: string) => {
  return `${url}?${new Date().getTime()}`;
};

const getBasePath = () => {
  let base = ENVs.StaticBucketUrl();
  let basePath = base === '' ? config.basePath : base;
  return basePath;
};

export const URLS = {
  Fairs: {
    getLogo: (fileUrl: string) => {
      if (fileUrl.startsWith('http')) {
        return fileUrl;
      } else if (fileUrl.startsWith('/userImages')) {
        return noCachUrl(`${getBasePath()}${fileUrl}`);
      } else {
        return noCachUrl(`${config.basePath}/api/Fairs/${fileUrl}`);
      }
    },
    getMap: (tag: string) => {
      if (ENVs.StaticBucketUrl() === '') {
        return noCachUrl(`${config.basePath}/api/Fairs/maps/${tag}`);
      } else {
        return noCachUrl(`${getBasePath()}/userImages/fairs/${tag}_map.svg`);
      }
    },
    getMapFromTag: (tag: String) => {
      if (ENVs.StaticBucketUrl() === '') {
        return noCachUrl(`${config.basePath}/api/Fairs/maps/${tag}`);
      } else {
        return noCachUrl(`/userImages/fairs/${tag}_map.svg`);
      }
    },
  },
  getMap: (tag: string) => {
    if (ENVs.StaticBucketUrl() === '') {
      return noCachUrl(`${config.basePath}/api/Fairs/maps/${tag}`);
    } else {
      return noCachUrl(`${getBasePath()}/userImages/fairs/${tag}_map.svg`);
    }
  },
  Machine: {
    getImage: (imageName: string) => noCachUrl(`${getBasePath()}/userImages/${imageName}`),
  },
  Software: {
    getImage: (imgUrl: string) => {
      if (imgUrl.startsWith('http')) {
        return imgUrl;
      } else if (imgUrl.startsWith('/userImages')) {
        return noCachUrl(`${getBasePath()}${imgUrl}`);
      } else if (imgUrl.startsWith('/images')) {
        return noCachUrl(`${config.basePath}/api/Softwares${imgUrl}`);
      } else {
        return noCachUrl(`${config.basePath}${imgUrl}`);
      }
    },
  },
};
